<template>
  <a-cascader
    v-show="info.status === 'edit'"
    v-model:value="value"
    :options="getOptions(widget.level)"
    :placeholder="'请选择' + info.title"
    :change-on-select="!widget.level"
    :show-search="{ filter }"
    style="width: 100%"
  />
  <div v-show="info.status === 'show'" class="view">
    <area-table :data="data" v-bind="$props" />
  </div>
</template>

<script lang="ts" setup>
import { computed, defineProps } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { AreaFieldType } from '@/components/business/crud/interface/FieldType';
import { getArea, getOptions } from '@/components/business/crud/widgets/impl/area';
import AreaTable from '@/components/business/crud/widgets/impl/AreaTable.vue';
import { ShowSearchType } from 'ant-design-vue/es/vc-cascader';

const filter: ShowSearchType['filter'] = (inputValue, path) => {
  return path.some(
    (option) =>
      option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
};

const props = defineProps<{
  propName: string;
  widget: AreaFieldType;
  info: WidgetInfo;
}>();
const data = ScForm.useFormData();

const value = computed({
  get() {
    return data.value[props.propName] ? getArea(data.value[props.propName]).ids : undefined;
  },
  set(val?: string[]) {
    data.value[props.propName] = val ? val[val.length - 1] : undefined;
  },
});
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
